export enum TrackedEvents {
  SetttingsViewed = 'settings_viewed',
  EnablingStarted = 'enabling_started',
  EnablingCompleted = 'enabling_completed',
  Disabled = 'disabled',
  EditCompleted = 'edit_completed',
  EditMessageClicked = 'edit_message_clicked',
  BuilderChosen = 'builder_chosen',
}
